import React from 'react';
import { connect } from 'react-redux'
import PerfilesyPermisos from './PerfilesyPermisos';

//Importación de actions.
import {
    getScreenData,
    resetStatePerfyPerm,
    selectProducto,
    selectCategoria,
    selectPrograma,
    setPerfilEdicion,
    setInfoPerfilToDelete,
    eliminarPerfil,
    nuevoPerfil,
    limpiarMensajes,
    editarPerfil,
    hidePopUp,
    addGroupWindows,
    deleteGroupWindows,
    stopClear,
    addGroupWindowsEdit,
    deleteGroupWindowsEdit,
    startClear,
    buscarPerfil
} from '../actions/PerfilesyPermisos';

const mapStateToProps = (state) => {
    return {
        data: state.perfilesyPermisos
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        resetStatePerfyPerm: () => {
            dispatch(resetStatePerfyPerm());
        },
        selectProducto: (id) => {
            dispatch(selectProducto(id));
        },
        selectCategoria: (id) => {
            dispatch(selectCategoria(id));
        },
        selectPrograma: (id) => {
            dispatch(selectPrograma(id));
        },
        setPerfilEdicion: (id, gruposWindows) => {
            dispatch(setPerfilEdicion(id, gruposWindows));
        },
        setInfoPerfilToDelete: (id) => {
            dispatch(setInfoPerfilToDelete(id));
        },
        eliminarPerfil: () => {
            dispatch(eliminarPerfil());
        },
        nuevoPerfil: (nombre, productoId, perfilId, tipoCopia, description) => {
            dispatch(nuevoPerfil(nombre, productoId, perfilId, tipoCopia, description));
        },
        limpiarMensajes: () => {
            dispatch(limpiarMensajes());
        },
        editarPerfil: (nombre, nuevoNombre, descripcion, nuevaDescripcion, productoId, gruposWindows, altaAutomatica) => {
            dispatch(editarPerfil(nombre, nuevoNombre, descripcion, nuevaDescripcion, productoId, gruposWindows, altaAutomatica));
        },
        hidePopUp: (nombre, nuevoNombre) => {
            dispatch(hidePopUp(nombre, nuevoNombre));
        },
        addGroupWindows: (id) => {
            dispatch(addGroupWindows(id));
        },
        deleteGroupWindows: (id) => {
            dispatch(deleteGroupWindows(id));
        },
        addGroupWindowsEdit: (idGrupo, idPerfil) => {
            dispatch(addGroupWindowsEdit(idGrupo, idPerfil));
        },
        deleteGroupWindowsEdit: (idGrupo, idPerfil) => {
            dispatch(deleteGroupWindowsEdit(idGrupo, idPerfil));
        },
        stopClear: () => {
            dispatch(stopClear());
        },
        buscarPerfil: (palabra) => {
            dispatch(buscarPerfil(palabra));
        },
        startClear: () => {
            dispatch(startClear());
        }
    }
}
 
//Connect entre el componente y las props y actions.
const PerfilesyPermisosContainer = connect(mapStateToProps, mapDispatchToProps)(PerfilesyPermisos);

export default PerfilesyPermisosContainer;